import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';

import { AutoComplete } from 'primeng/autocomplete';

import { ApiMemberInfo } from 'sc-common';

@Component({
    selector: 'sc-search-member',
    templateUrl: './search-member.component.html',
    standalone: false
})
export class SearchMemberComponent {

    @Input()
    public members: ApiMemberInfo[];

    @Input()
    public emptyMessage: string;

    @Output()
    public readonly filter = new EventEmitter<string>();

    @Output()
    public readonly selectItem = new EventEmitter<ApiMemberInfo>();

    @ViewChild('autocomplete')
    private _autoComplete: AutoComplete;

    public selectedMember: ApiMemberInfo | null = null;

    public completeMethod(event: { query: string; }): void {
        if (!event.query) {
            return;
        }

        this.filter.next(event.query);
    }

    public onSelect(member: ApiMemberInfo): void {
        this.selectItem.next(member);

        this.selectedMember = null;
        // Force the UI input to clear
        if (this._autoComplete) {
            this._autoComplete.clear();
        }
    }
}
